import { ca } from '@cian/analytics';

export interface ISmbTrackingUser {
  userId: number;
  isAuthorized: boolean;
}

interface ISmbEventParams {
  action: string;
  label?: string;
  extra?: Record<string, unknown>;
}

type TSmbEvent = (user: ISmbTrackingUser, runtimeExtra?: Record<string, unknown>) => void;

const SMB_EVENT_CATEGORY = 'landing_guide_profi';
const SMB_PAGE_TYPE = 'landing_guide_profi';

export const SMB_FIRST_TIME_BANNER_NAME = 'FirstTimeBanner';
export const SMB_BLUE_BANNER_NAME = 'BlueBanner';

export const createSmbEvent = ({ extra, ...params }: ISmbEventParams): TSmbEvent => {
  return (user: ISmbTrackingUser, runtimeExtra?: Record<string, unknown>): void => {
    ca('eventSite', {
      name: 'oldevent',
      category: SMB_EVENT_CATEGORY,
      ...params,
      page: {
        pageType: SMB_PAGE_TYPE,
        extra: {
          ...extra,
          ...runtimeExtra,
        },
      },
      user: getSmbEventUser(user),
    });
  };
};

function getSmbEventUser(user: ISmbTrackingUser): Record<string, unknown> {
  if (!user.isAuthorized) {
    return {};
  }

  return { userId: user.userId };
}

/** Клик по кнопке «Разместить объявление» в баннерах SMB */
export const caSmbButton = createSmbEvent({
  action: 'click',
  label: 'button',
  extra: {
    buttonText: 'Разместить объявление',
  },
});

/** Пользователь кликнул на статью в лендинге */
export const caSmbArticle = createSmbEvent({
  action: 'click',
  label: 'article',
});

/** Пользователь кликнул на вопрос FAQ */
export const caSmbQuestion = createSmbEvent({
  action: 'click',
  label: 'question',
});
